export default "<div fxLayout=\"row\" class=\"icon-title\">\r\n  <img alt=\"icon\" [src]=\"iconPath\" />\r\n  <h5>{{ title }}</h5>\r\n</div>\r\n"